/**
 * @prettier
 */

class CcpaPage {
  formSubmissionListeners() {
    const $form = $('.js-ccpa-form')

    $form.on({
      'ajax:success': (e, data) => {
        const message = _.get(data, 'result.message')

        Utils.trackGAEvent('ccpa form', 'Submit to personal data removal request')
        Modal.show({ title: 'Thank you', content: message })
        $form.trigger('reset')
      },
      'ajax:error': (e, data) => {
        const message = _.get(data, 'responseJSON.result.error_message')

        NotificationBar.show(message || 'Something went wrong', 'error', 8000)
      },
      'ajax:complete': () => {
        grecaptcha?.reset()
      },
    })
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.formSubmissionListeners()

      if (document.querySelector('.js-data-removals-show-popup')) {
        Modal.init()
        Modal.show({
          content: 'Your data will be deleted soon and you will be notified via email',
        })
      }
    })
  }
}

const ccpaPage = new CcpaPage()

ccpaPage.init()
